import { Panel } from "primereact/panel";
import * as generic from "../../../../../components/Generico";
import { Divider } from "primereact/divider";
import { DeclaracionClientePj } from "../../../../../models/trust/clientepj/DeclaracionClientePj";
import { useForm } from "react-hook-form";
import { ClientePjService } from "../../../../../service/trust/ClientePjService";
import { InputComponent } from "../../../../../components/InputComponent";
import { useEffect, useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { BottomActionBar } from "../../../../../components/ui/BottomActionBar";

export const DeclaracionCliente = ({ toast, id, permss, soloLectura, handlePrev, handleNext, catalogos, nuevoCliente }) => {

    const omodel = new DeclaracionClientePj();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues, shouldTrim: true });
    const clientePjServicio = new ClientePjService();
    const { inText, inDrop } = InputComponent({ omodel, errors, control, permss, id, soloLectura });

    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [esPep, setEsPep] = useState(false);
    const [esRelacionPep, setEsRelacionPep] = useState(false);
    const [esFondosTerceros, setEsFondosTerceros] = useState(false);

    useEffect(() => {
        if (id) {
            editFicha();
        } else {
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [id]);

    const editFicha = () => {
        setIsLoading(true);
        clientePjServicio.consultarCliente(id, { seccion: 'seccion4' }).then(res => {
            const _cli = res.data.cliente;
            if (!_cli) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }
            setEsPep(_cli.pep?.cat_id === true);
            setEsRelacionPep(_cli.relacion_pep?.cat_id === true);
            setEsFondosTerceros(_cli.origen_fondo?.nemonico === 'TP_OI_TF_OTRO_TERCERO');

            reset(generic.renewValues(_cli, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onSubmit = (data) => {
        setIsSaving(true);
        data.seccion = 'seccion4';
        data.id = id;

        clientePjServicio.editarCliente(data).then(res => {
            nuevoCliente(res.data);
            generic.funcSuccess(res, toast);
            handleNext();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Revise los campos requeridos antes de guardar.', life: 3000 });
    }

    const onChangeOrigenFondo = (e) => {
        const isTerceros = e.value?.nemonico === 'TP_OI_TF_OTRO_TERCERO';
        setEsFondosTerceros(isTerceros);
        if (!isTerceros) setValue('nombre_aportara_relacion', '');
    }

    const onChangePep = (e) => {
        const isPep = e.value?.cat_id === true;
        setEsPep(isPep);
        if (!isPep) {
            setValue('cargo_pep', '');
            setValue('tiempo_pep', '');
        }
    }

    const onChangeRelacionPep = (e) => {
        const isRelacion = e.value?.cat_id === true;
        setEsRelacionPep(isRelacion);
        if (!isRelacion) {
            setValue('nombre_pep', '');
            setValue('cargo_nombre_pep', '');
            setValue('tiempo_nombre_pep', '');
            setValue('tipo_relacion_pep', '');
        }
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <div className="p-fluid">
            <form id="seccion4Form" onSubmit={handleSubmit(onSubmit, onError)}>

                <Panel header={generic.renderPanelHeader('I', 'ORIGEN DE LOS FONDOS / BIENES', 'pi pi-money-bill')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid p-2">
                        {inDrop('origen_fondo', catalogos?.origen_fondo, { lab: omodel.optionLabel, chn: onChangeOrigenFondo }, 12)}
                        {esFondosTerceros && inText('nombre_aportara_relacion', { icon: 'pi pi-users' }, 12)}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('J', 'DECLARACIÓN DE PERSONA EXPUESTA POLÍTICAMENTE (PEP)', 'pi pi-id-card')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid p-2">
                        {inDrop('pep', generic.estadosSiNo, { lab: 'nombre', chn: onChangePep, val: true }, 12)}
                        {esPep && inText('cargo_pep', { icon: 'pi pi-briefcase' }, 6)}
                        {esPep && inText('tiempo_pep', { icon: 'pi pi-clock' }, 6)}
                    </div>
                    <Divider />
                    <div className="formgrid grid p-2">
                        {inDrop('relacion_pep', generic.estadosSiNo, { lab: 'nombre', chn: onChangeRelacionPep, val: true }, 12)}
                        {esRelacionPep && inText('nombre_pep', { icon: 'pi pi-user' }, 6)}
                        {esRelacionPep && inText('cargo_nombre_pep', { icon: 'pi pi-briefcase' }, 6)}
                        {esRelacionPep && inText('tiempo_nombre_pep', { icon: 'pi pi-clock' }, 6)}
                        {esRelacionPep && inText('tipo_relacion_pep', { icon: 'pi pi-link' }, 6)}
                    </div>
                </Panel>

                <Panel header={generic.renderPanelHeader('K', 'DECLARACIÓN SOBRE ORIGEN Y DESTINO LÍCITO DE RECURSOS', 'pi pi-check-circle')} className="panel-ficha shadow-1 mb-4">
                    <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                        {omodel.msgOrigenLicito}
                    </div>
                </Panel>
                <BottomActionBar layoutVersion="v2" onPrev={handlePrev} onNext={handleNext} loading={isSaving} isReadOnly={soloLectura} />
            </form>

        </div>
    );
}